import { useMutation, useQuery } from '@tanstack/react-query';
import LoadingSpinner from 'components/loadingSpinner';
import { UserWithBrokerMandate } from 'models/user';
import { ChangeEvent, FormEvent, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';

import {
  EmailUpdateResponse,
  getAccountInfo,
  start,
  verifyCurrentEmail,
} from '../../api';
import { CodeConfirmationView } from './CodeConfirmation.view';

export const CodeConfirmationContainer = () => {
  const [code, setCode] = useState('');
  const history = useHistory();

  const {
    data,
    isLoading: isLoadingAccountInfo,
    error: accountInfoError,
  } = useQuery<UserWithBrokerMandate>({
    queryKey: ['updateEmailAccountInfo'],
    queryFn: getAccountInfo,
    cacheTime: 0,
  });

  const {
    mutate: emailUpdateStart,
    isLoading: isEmailUpdateStarting,
    error: emailUpdateStartError,
    data: emailUpdateStartData,
  } = useMutation<EmailUpdateResponse>({
    mutationFn: start,
  });

  const {
    mutate: verifyCode,
    isLoading: isVerifyingCode,
    error: verifyCodeError,
  } = useMutation<EmailUpdateResponse>({
    mutationFn: () =>
      verifyCurrentEmail({
        code,
        requestId: emailUpdateStartData?.requestId ?? '',
      }),
    onSuccess: (response) => {
      history.push(`/me/update-email/enter-email/${response.requestId}`);
    },
  });

  useEffect(() => {
    emailUpdateStart();
  }, [emailUpdateStart]);

  const handleOnChange = (event: ChangeEvent<HTMLInputElement>) => {
    setCode(event.target.value);
  };

  const handleCodeSubmit = (event: FormEvent) => {
    event.preventDefault();
    verifyCode();
  };

  if (isLoadingAccountInfo || isEmailUpdateStarting) {
    return <LoadingSpinner />;
  }

  return (
    <CodeConfirmationView
      error={emailUpdateStartError || accountInfoError || verifyCodeError}
      email={data?.email}
      handleSubmit={handleCodeSubmit}
      handleOnChange={handleOnChange}
      isLoading={isVerifyingCode}
      code={code}
      onSendNewCode={emailUpdateStart}
    />
  );
};
